import React, { Component } from 'react';
import { FiCast, FiLayers, FiUsers, FiMonitor, FiCheck } from 'react-icons/fi';
import ReactCardCarousel from 'react-card-carousel';
const ChooseList = [
	{
		icon: <FiCheck />,
		title: 'One-Stop-Shop',
		description: '',
	},
	{
		icon: <FiCheck />,
		title: 'Reliable',
		description: '',
	},
	{
		icon: <FiCheck />,
		title: 'Professional',
		description: '',
	},
	{
		icon: <FiCheck />,
		title: 'Trusted',
		description: '',
	},
	{
		icon: <FiCheck />,
		title: 'Cheap and Affordable',
		description: '',
	},
	{
		icon: <FiCheck />,
		title: 'Offer flex payment to our customers',
		description: '',
	},
	{
		icon: <FiCheck />,
		title: 'Licensed and Insured',
		description: '',
	},
];

class ServiceTwo extends Component {
	static get CONTAINER_STYLE() {
		return {
			position: 'relative',
			height: '50vh',
			width: '100%',
			display: 'flex',
			flex: 1,
			justifyContent: 'center',
			alignItems: 'middle',
		};
	}

	static get CARD_STYLE() {
		return {
			height: '300px',
			width: '500px',
			padding:'5vh',
			paddingTop: '60px',
			textAlign: 'center',
			background: '#fff',
			fontFamily: 'sans-serif',
			fontSize: '12px',
			textTransform: 'uppercase',
			borderRadius: '10px',
			boxSizing: 'border-box',
			boxShadow: '0px 0px 10px #ccc',
		};
	}

	render() {
		const { column } = this.props;
		const ServiceContent = ChooseList.slice(0, this.props.item);

		return (
			<React.Fragment>
				<div className='row'>
					{/* <ul className="choose__style--2">
						{ServiceContent.map((val, i) => (
							<li className={`${column}`} key={i}>
								<div className='why-choose'>
									<div className='row'>
										<div className='col-lg-1'>
											<div className='icon'>{val.icon}</div>
										</div>
										<div className='col-lg-10'>
											<div className='choose-content'>
												<h3 className='title'>{val.title}</h3>
											</div>
										</div>
									</div>
								</div>
							</li>
						))}
					</ul> */}
					<div style={ServiceTwo.CONTAINER_STYLE}>
						<ReactCardCarousel autoplay={true} autoplay_speed={3000} spread={'wide'}>
							{ServiceContent.map((val, i) => (
								<div className="whychooseus-carousel--style" key={i} style={ServiceTwo.CARD_STYLE}>
									<h3>{val.title}</h3>
								</div>
							))}
						</ReactCardCarousel>
					</div>
				</div>
			</React.Fragment>
		);
	}
}
export default ServiceTwo;
